import {Component, OnInit} from '@angular/core';
import {Attachment} from '../../../types/email-data.types';
import {NoticesService} from '../../../services/notices.service';

@Component({
    selector: 'zoom-image-modal',
    templateUrl: './zoom-image-modal.component.html',
    styleUrls: ['./zoom-image-modal.component.scss']
})
export class ZoomImageModalComponent implements OnInit {
    showModal = false;
    data: Attachment;

    constructor(
        public noticesService: NoticesService,
    ) {}

    ngOnInit(): void {
        this.data = this.noticesService.attachmentInViewAttachmentModal;

        setTimeout(() => this.showModal = true, 500);
    }

    hideModal(): void {
        this.noticesService.isViewAttachmentModalShow = false;
        this.noticesService.attachmentInViewAttachmentModal = null;
    }

    setImage(icon?) {
        // document.getElementsByClassName('note-editable')[0].innerHTML = `<img src="${icon}">`;
        document.getElementsByClassName('note-editable')[0].innerHTML += '<img style="width: 500px;" src="https://www.w3schools.com/w3css/img_fjords.jpg">';
        this.hideModal();
        this.noticesService.isChooseIconModalShow = false;
    }

}




// WEBPACK FOOTER //
// /app/src/app/views/notices/zoom-image-modal/zoom-image-modal.component.ts